<template>
  <!-- 试卷列表 列表页 -->
  <div class="board">
    <div v-hasPermi="['review:testPaper:list']">
      <div class="title">
                <span><el-button type="text" icon="el-icon-arrow-left"
                                 @click="$router.push({name:'marking'})">{{ markingPaperTextConfig.back }}</el-button><el-divider
                    direction="vertical"></el-divider><span class="name">{{
                    markingPaperTextConfig.title
                  }}</span></span>
      </div>
      <p class="info">
        <span>{{ infoTextConfig.examPlan }}：</span>{{ info.exam.examPlanName }}
        <span>{{ infoTextConfig.subject }}：</span>{{ info.exam.subject }}
        <span>{{ infoTextConfig.examPaperName }}：</span>{{ info.exam.examPaperName }}
        <span>{{ infoTextConfig.questionSort }}：</span>{{ subjectivityLabel + info.questionSort }}
        <span>{{ infoTextConfig.reviewEndTime }}：</span>{{ info.exam.reviewEndTime }}
        <span>{{ infoTextConfig.noReview }}：</span>{{ info.reviewTotal - info.reviewedNum }} / {{ info.reviewTotal }}
      </p>
      <el-form :inline="true" :model="form" ref="form">
        <el-form-item>
          <el-input v-model="form.startScore" type="number" min="0" clearable :placeholder="searchTextConfig.startScore"
                    style="width:120px"></el-input>
          -
          <el-input v-model="form.endScore" type="number" min="0" clearable :placeholder="searchTextConfig.endScore"
                    style="width:120px"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="form.status" clearable :placeholder="searchTextConfig.status">
            <el-option v-for="item in statusOptions" :key="item.dict_value" :label="item.dict_label"
                       :value="item.dict_value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search(1)">{{ searchTextConfig.select }}</el-button>
          <el-button @click="reset">{{ searchTextConfig.reset }}</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="tableData" v-loading="loading" element-loading-text="加载中"
                element-loading-spinner="el-icon-loading" ref="multipleTable" stripe size="medium"
                :height="height" style="width:100%">
        <el-table-column prop="id" :label="tableTextConfig.id" :min-width="flexColumnWidth('id',4,tableData)"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="score" :label="tableTextConfig.score" min-width="100px"></el-table-column>
        <el-table-column prop="reviewDate" :label="tableTextConfig.reviewDate" min-width="100px"></el-table-column>
        <el-table-column :label="tableTextConfig.status" min-width="125px">
          <template slot-scope="scope">
            <el-tag
                :type="scope.row.status===2?'warning':scope.row.status===1?'success':scope.row.status===3?'info':''">
              {{ reviewStatusFormatter(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column fixed="right" :label="tableTextConfig.operate" min-width="170px">
          <template slot-scope="scope">
            <el-button v-hasPermi="['arrangement:answer:find:teacher']" plain type="primary" size="mini"
                       :disabled="scope.row.status===1 || new Date() > new Date(info.exam.reviewEndTime)"
                       @click="review(scope.row)">{{ tableTextConfig.button.review.name }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="tableData.length" :currentPage.sync="form.pageNumber" :pageSize.sync="form.pageSize"
                  :total.sync="total"></pagination>
    </div>
  </div>
</template>

<script>
import pagination from '@/components/pagination/pagination.vue'
import {getDict} from "@/api/dict";

export default {
  name: 'markingPaper',
  components: {
    pagination
  },
  data() {
    return {
      height: 250,
      loading: true,
      info: {},
      form: {
        reviewerId: '',
        startScore: '',
        endScore: '',
        status: '',
        examStatus: '',
        pageNumber: 1,
        pageSize: 20
      },
      total: 0,
      statusOptions: [],
      tableData: [],
      row: null,
      subjectivityLabel: ""
    }
  },
  created() {
    getDict('question_type').then(res => {
      let subjectivity = res.data.find(item => item.dict_value == 'subjectivity')
      this.subjectivityLabel = subjectivity ? subjectivity.dict_label : '主观题'
    })
    getDict('question_review_status').then(res => {
      this.statusOptions = res.data
    })
    const id = localStorage.getItem('current_teacher_review_plan_id');
    if (id) {
      this.getTeacherReviewPlanInfo(id);
      this.form.reviewerId = id;
      this.search(1)
    }
  },
  mounted() {
    const that = this;
    setTimeout(() => {
      that.updateHeight()
    }, 200);
    window.onresize = () => {
      that.updateHeight()
    };
  },
  computed: {
    markingPaperTextConfig() {
      return this.$store.state.global.textConfig.backend.markingPaper
    },
    infoTextConfig() {
      return this.markingPaperTextConfig.info
    },
    searchTextConfig() {
      return this.markingPaperTextConfig.search
    },
    tableTextConfig() {
      return this.markingPaperTextConfig.table
    },
  },
  watch: {
    tableData() {
      if (this.tableData.length == 0) {
        this.height = 120
      } else {
        this.updateHeight()
      }
    }
  },
  methods: {
    getTeacherReviewPlanInfo(id) {
      this.$store.dispatch('getTeacherReviewPlanInfo', id).then(res => {
        if (res.status == 200 && res.data) {
          this.info = res.data
          localStorage.setItem('setMarkingPaperInfo', JSON.stringify(res.data))
        }
      })
    },
    getTagValue(val, options) {
      for (let i = 0; i < options.length; i++) {
        const e = options[i];
        if (e.value == val) {
          return e.label
        }
      }
    },
    search(val) {
      this.loading = true
      if (val) {
        this.form.pageNumber = val
      }
      this.$store.dispatch("getTestPaperList", this.form).then(res => {
        if (res.status == 200) {
          this.tableData = res.data.list
          this.total = res.data.total
        }
        this.loading = false
        this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
      }).catch(err => {
        console.log(err);
        this.loading = false
      })
    },
    reset() {
      this.form = this.$options.data().form
      this.form.pageSize = 20
      this.form.reviewerId = this.info.id
      this.search(1)
    },
    edit(row) {
      this.row = row
      this.specialDialogVisible = true
    },
    review(row) {
      let data = {
        id: row.id,
        answerSheetId: row.answerSheetId,
        examPaperId: this.info.exam.examPaperId,
        questionId: row.questionId,
        reviewedNum: this.info.reviewedNum,
        reviewTotal: this.info.reviewTotal,
        reviewerId: this.info.id
      }
      localStorage.setItem('setPaperReviewInfo', JSON.stringify(data))
      this.$router.push({name: 'reviewPaper'})
    },
    updateHeight() {
      if (document.getElementsByClassName('el-form')[0]) {
        this.height = document.getElementsByClassName('board')[0].clientHeight - document.getElementsByClassName('el-form')[0].clientHeight - 182
        this.height = this.height < 460 ? 460 : this.height
      }
    },
    reviewStatusFormatter(val) {
      let already = this.statusOptions.find(item => item.dict_value == val)
      return already ? already.dict_label : ''
    }
  }
}
</script>

<style scoped>
.info {
  color: #555;
  font-size: 15px;
  margin-bottom: 12px;
}

.info span {
  color: #C0C4CC;
  margin-left: 12px;
}

.info span:first-child {
  margin-left: 0;
}

.info i {
  color: #555;
}
</style>
